import React from "react";

//Styles
import "./styles.scss";

//Data
import FooterColorLineData from "../../Services/data/footerColorLineData";

const FooterColorLine = () => {
  return (
    <div className="footerColorLine-container">
      {FooterColorLineData.map((item, index) => {
        return (
          <div
            key={index}
            className="footerColor"
            style={{ background: item?.color, height: "16px" }}
          />
        );
      })}
    </div>
  );
};

export default FooterColorLine;
